<fgb-mobile-page-header [pageTitle]="'wallet.page.title'" [showQr]="false" [showBalance]="false" [showAppleWallet]="true" />
<fgb-banner class="d-lg-block d-none" [title]="'wallet.page.title' | translate" />

<ng-container *ifScreenSize="screenSize.Mobile">
  <ng-container *ngIf="member$ | async as member">
    <div class="bg-primary wallet-wrapper">
      <div class="container mt-1">
        <div class="mobile-pass bg-glass ms-auto">
          <fgb-mobile-pass [memberId]="member.MemberId"></fgb-mobile-pass>
        </div>
        <ng-container *notInPopulation="[populations.U18]">
          <div class="points-wrapper">
            <div class="bg-glass">
              <i class="material-symbols-outlined">loyalty</i>
              <div class="points-info">
                <span class="points"> {{ pointsBalance$ | async | number: '1.0-0' }}</span>

                <span class="points-text">{{ 'member.card.points.label' | translate: { fgbdefault: 'Your Points' } }}</span>
              </div>
            </div>
            <div class="bg-glass">
              <i class="material-symbols-outlined">money_bag</i>
              <div class="points-info">
                <span class="points"> {{ ecash$ | async | FortressCurrencyPipe }}</span>
                <span class="points-text">{{ 'member.card.cashback.label' | translate: { fgbdefault: 'Cashback' } }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-container>
<div class="mobile-container" #sheet>
  <div class="sheet-handle d-lg-none d-flex" #sheetHandle>
    <span class="sheet-handle-grabber"></span>
  </div>
  <div class="sheet-content" #sheetContent>
    <div class="container">
      <ng-container *ifScreenSize="screenSize.Desktop">
        <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
      </ng-container>
    </div>
    <ng-container *notInPopulation="[populations.U18]">
      <fgbcl-campaigns-offers-list [showAllOffers]="false"></fgbcl-campaigns-offers-list>
    </ng-container>

    <div class="container">
      <!-- Wallet -->
      <ng-container *ngIf="walletItems$ | async as walletItems">
        <div class="wallet-redeem-carousel pt-lg-4 pt-3">
          <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
        </div>
      </ng-container>

      <div class="mt-3 text-center mb-5">
        <div class="claimed-button">
          <div class="claimed-button-text align-items-lg-start align-items-center">
            <h5 class="mb-1">{{ 'rewards.wallet.redemption.history' | translate: { fgbdefault: 'REDEMPTION HISTORY' } }}</h5>
            <div class="font-size-14">
              {{
                'rewards.wallet.redemption.history.description' | translate: { fgbdefault: 'View history of your redemptions' }
              }}
            </div>
          </div>
          <a
            class="font-size-14 claimed-text fw-bold btn btn-primary border-tertiary rounded text-tertiary"
            [routerLink]="['/rewards/claimed']"
          >
            {{ 'rewards.wallet.view.claimed' | translate }}
          </a>
        </div>
      </div>
    </div>
    <ng-container *ifScreenSize="screenSize.Mobile">
      <fgb-footer></fgb-footer>
    </ng-container>
  </div>
</div>
